import { Path } from "../Path";

/**
 * @param {import("@seabrookstudios/pitch2table-core").ServerConfig["conventionCalendarEvents"]|undefined} conventionCalendarEvents
 * @param {import("@seabrookstudios/pitch2table-core").AttendedConventions} convention
 * @returns {import("@seabrookstudios/pitch2table-core").ConventionId|undefined}
 */
export const getEventIdForAttendedConvention = (conventionCalendarEvents, convention) => {
  return conventionCalendarEvents?.[convention];
};

/**
 * @param {import("@seabrookstudios/pitch2table-core").ServerConfig["conventionCalendarEvents"]|undefined} conventionCalendarEvents
 * @param {import("@seabrookstudios/pitch2table-core").ConventionId} conventionId
 * @returns {import("@seabrookstudios/pitch2table-core").AttendedConventions|undefined}
 */
export const getAttendedConventionForEvent = (conventionCalendarEvents, conventionId) => {
  if (!conventionCalendarEvents) {
    return undefined;
  }

  const match = Object.entries(conventionCalendarEvents).find(([, eventId]) => eventId === conventionId);
  return match ? /** @type {import("@seabrookstudios/pitch2table-core").AttendedConventions} */ (match[0]) : undefined;
};

/**
 * @param {import("@seabrookstudios/pitch2table-core").AttendedConventions} attendedConvention
 * @returns {import("react-router-dom").To}
 */
export const getPublishersLinkForAttendedConvention = (attendedConvention) => {
  const params = new URLSearchParams();
  params.set("CONVENTIONS", attendedConvention.toUpperCase());

  return {
    pathname: Path.publishers().pathname,
    search: `?${params.toString()}`,
  };
};
